import * as z from "zod";

export interface LoginBodyDto {
    user: {
        login: string;
        password: string;
    };
}

const LoginDataDtoSchema = z
    .object({
        id: z.int().positive(),
        company_id: z.int().positive().nullable(),
        email: z.string().trim(),
        locale: z.string().trim().nullable(),
        roles: z.array(z.string().trim()),
        time_zone: z.string().trim(),
        username: z.string().trim().nullable(),
    })
    .readonly();

export const LoginDtoSchema = z
    .object({
        user: LoginDataDtoSchema,
        auth_token: z.string().trim(),
    })
    .readonly();

export type LoginDto = z.output<typeof LoginDtoSchema>;

/**
 * Body of the 429 login response. `blocked_until` is the unlock instant in
 * ISO-8601 UTC; the rest of the body (error_code 1002, status "blocked", ...)
 * is not needed by the client.
 */
export const LoginBlockedDtoSchema = z
    .object({
        blocked_until: z.iso.datetime({ offset: true }),
    })
    .readonly();
